import { setupForDark } from '@theme';
import classNames from 'classnames';

// Outline (single-contour) paths — the ring (tr) and frame (br) use only their outer
// contour so the stroke draws one clean outline. pathLength=100 normalizes the dash
// across the four shapes (different real lengths) → uniform draw progress.
const SHAPES: { key: string; d: string; animation: string }[] = [
  {
    key: 'tl',
    animation: 'animate-logo-rewind-tl',
    d: 'M20.1097 9.8457H10.9065C9.78523 9.8457 8.86246 10.7077 8.86246 11.769V20.3995C8.86246 21.4574 9.78523 22.3228 10.9065 22.3228H20.1097C21.2379 22.3228 22.1537 21.4574 22.1537 20.3995V11.769C22.1537 10.711 21.2379 9.8457 20.1097 9.8457Z'
  },
  {
    key: 'tr',
    animation: 'animate-logo-rewind-tr',
    d: 'M31.9997 9.8457C28.5993 9.8457 25.8457 12.6042 25.8457 16.0026C25.8457 19.4011 28.5993 22.1534 31.9997 22.1534C35.3998 22.1534 38.1534 19.4011 38.1534 16.0026C38.1534 12.6042 35.3937 9.8457 31.9997 9.8457Z'
  },
  {
    key: 'bl',
    animation: 'animate-logo-rewind-bl',
    d: 'M15.2591 25.6863C11.5855 25.6863 8.61523 28.4813 8.61523 31.923C8.61523 35.3647 11.589 38.1534 15.2591 38.1534C18.9292 38.1534 21.896 35.3647 21.896 31.923C21.896 28.4813 18.9223 25.6863 15.2591 25.6863Z'
  },
  {
    key: 'br',
    animation: 'animate-logo-rewind-br',
    d: 'M35.9012 24.6152H26.8677C25.6236 24.6152 24.6152 25.6264 24.6152 26.8733V35.9027C24.6152 37.1458 25.6236 38.1537 26.8677 38.1537H35.9012C37.1453 38.1537 38.1537 37.1458 38.1537 35.9027V26.8733C38.1537 25.6301 37.1453 24.6152 35.9012 24.6152Z'
  }
];

export default function BrandLoader({ size = 96 }: { size?: number }) {
  return (
    <div
      data-testid='brand-loader'
      className={classNames(
        'w-full h-full flex items-center justify-center',
        setupForDark('bg-page')
      )}
    >
      <svg
        width={size}
        height={size}
        viewBox='0 0 48 48'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        {SHAPES.map((shape) => (
          <path
            key={shape.key}
            d={shape.d}
            pathLength={100}
            fill='none'
            className={classNames(
              'stroke-white dark:stroke-black [stroke-width:1.4] [stroke-dasharray:100]',
              shape.animation,
              'motion-reduce:animate-none'
            )}
          />
        ))}
      </svg>
    </div>
  );
}
